export const metaMixin = {
	data() {
		return {
			statusses: [],
			job_types: [],
			divisions: [],
			countries: [],
			can_enterjobno: false
			
		}
	},
	methods:{

		load_meta_data() {
			let self = this; // make sure we can access this inside of our promisses
			this.errormsg = '';

			axios
				.get("/api/jobs/meta", {
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}


					if (json.status == "OK") {
						// console.log(json)

						// get statusses
						self.statusses = json.data.substatusses;
						self.statusses.sort(function(a,b) {
							if (a.group < b.group) {
								return -1;
							} else if (a.group > b.group) {
								return 1;
							} else {
								return a.order - b.order;
							}
						});
						// self.groups_to_statusses();   This NEED to be fixed.

						self.job_types = json.data.jobtypes;
						self.job_types.sort(function(a,b) { return a.order - b.order });
						self.divisions = json.data.divisions;
						self.divisions.sort(function(a,b) { return a.display_name < b.display_name });
						self.countries = json.data.countries;
						self.countries.sort(function(a,b) { return a.display_name < b.display_name });
						self.can_enterjobno = json.data.can_enterjobno;
						
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				});
		},
		status_desc(id) {
			for (let i = 0; i < this.statusses.length; i++) {
				if (this.statusses[i].id == id) {
					return this.statusses[i].desc
				}
			}

			return "???"
		},
		jobtype_desc(id) {
			for (let i = 0; i < this.job_types.length; i++) {
				if (this.job_types[i].id == id) {
					return this.job_types[i].desc
				}
			}

			return "???"
		},
	}
}
